import React, { useEffect, useContext, useRef } from 'react';
import api from '../api';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import LoadingLogo from '../components/general/LoadingLogo';
import { useTranslation } from 'react-i18next';
import { verifiedUserInfo } from '../utils/accountUpdates';

const EmailVerificationScreen = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const processedTokenRef = useRef(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const redirect = queryParams.get('redirect') || '/'; // Get redirect parameter or default to '/'

    if (processedTokenRef.current === token) {
      return; // if the token has already been handled -> skip trying to verify it again
    }

    if (!token) {
      // if the url does not include a token:
      navigate('/', { replace: true }); // navigate the user to the homescreen ({ replace: true } tells React Router to update the current history entry instead of pushing a new one onto the browser’s history stack.)
      return; // skip the rest of the useEffect
    }

    processedTokenRef.current = token; // mark the token as already used, so the useEffect can't try to verify the token a second time

    if (token) {
      api
        .get(`/api/users/verify-email?token=${encodeURIComponent(token)}`)
        .then((response) => {
          toast.success(t('email-verification-screen-email-verified'));
          const verifiedUser = response.data;

          if (userInfo) {
            if (userInfo.userId === verifiedUser.userId) {
              // If the signed-in user is the same as the verified user, update the userInfo and navigate to profile
              const updatedUserInfo = verifiedUserInfo(userInfo, verifiedUser);
              ctxDispatch({ type: 'USER_SIGNIN', payload: updatedUserInfo });
              localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
              navigate('/profile', { replace: true }); // { replace: true } tells React Router to update the current history entry instead of pushing a new one onto the browser’s history stack.
            } else {
              // If the signed-in user is different from the verified user, inform the user and suggest signing in to the appropriate account
              navigate('/', { replace: true }); // { replace: true } tells React Router to update the current history entry instead of pushing a new one onto the browser’s history stack.
            }
          } else {
            navigate(`/signin?redirect=${encodeURIComponent(redirect)}`, {
              replace: true,
            }); // If user is not signed in, navigate to sign in with redirect ({ replace: true } tells React Router to update the current history entry instead of pushing a new one onto the browser’s history stack.)
          }
        })
        .catch((error) => {
          navigate('/', { replace: true }); // { replace: true } tells React Router to update the current history entry instead of pushing a new one onto the browser’s history stack.
          toast.error(t('email-verification-screen-verification-fail'));
        });
    }
  }, [location.search, navigate, ctxDispatch, userInfo, t]);

  return (
    <div className="email-verification-container">
      <LoadingLogo />

      <h1>{t('email-verification-screen-verifying-email')}</h1>
    </div>
  );
};

export default EmailVerificationScreen;
